import { Card } from '@mantine/core'
import { useParams } from 'react-router-dom'

import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { TBreadCrumbItems } from 'src/v2/commons/components/Breadcrumb'
import BasicTemplate from 'src/v2/commons/templates/BasicTemplate'

import EmailDomainInformation from '../components/EmailDomainInformation/EmailDomainInformation.component'
import MembershipInformation from '../components/MembershipInformation/MembershipInformation.component'
import UserInformation from '../components/UserInformation/UserInformation.component'
import { useUserEdit } from '../hooks/useUserEdit.hook'

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Administration Panel' },
  { title: 'Users' },
]

const SingleUserView = () => {
  const { userId = '' } = useParams<{ userId: string }>()

  const {
    isLoadingUser,
    isLoadingEdit,
    editMode,
    userForm,
    setEditMode,
    submitForm,
    cancelEdit,
    membershipData,
    emailDomains,
  } = useUserEdit(userId)

  return (
    <BasicTemplate
      isLoading={isLoadingUser}
      title="User Details"
      breadCrumbItems={breadCrumbItems}
    >
      <Card shadow="lg" radius="sm">
        <UserInformation
          loading={isLoadingEdit}
          onSubmit={submitForm}
          userInformationForm={userForm}
          editForm={editMode}
          setEditForm={setEditMode}
          handleCancelForm={cancelEdit}
        />

        <MembershipInformation membership={membershipData} />

        <EmailDomainInformation
          emailDomains={emailDomains}
          userMembershipId={membershipData.id}
        />
      </Card>
    </BasicTemplate>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  SingleUserView,
  'is_get_roles_enabled',
  true,
)
